import Icon from 'material-ui/Icon/Icon';

export default Icon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Icon/index.ts